export default {
  path: '/travel-documents/disposition',
  name: 'Disposition',
  component: () => import(/* webpackChunkName: "base" */ '../views/DispositionView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
